import { levelEntry } from "../campaign/entrypoint.ts";

export const entrypoints = [levelEntry("anuncio", () => import("./view.tsx"))];
